import googleConfig from '@/config/googleOAuth';
import metrics from '@/services/metrics';
import { getAllViewCounters, deleteAllViewCounters } from '@/hooks/useTrackPageViews'; // Add a script to the DOM to load
// the google recaptcha library

export function appendGoogleRecaptchaScript() {
  if (window.grecaptcha) {
    return Promise.resolve(window.grecaptcha);
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${googleConfig.appCheckSiteKey}`);
    script.addEventListener('load', () => resolve(window.grecaptcha));
    script.addEventListener('error', err => reject(err));
    document.head.appendChild(script);
  });
} // Request a Google Recaptcha token
// after loading the google recaptcha deps

export function getRecaptchaToken() {
  return new Promise((resolve, reject) => {
    appendGoogleRecaptchaScript().then(recaptcha => {
      recaptcha.ready(() => {
        recaptcha.execute(googleConfig.appCheckSiteKey, {
          action: 'submit'
        }).then(token => {
          resolve(token);
        }, reject);
      });
    });
  });
} // Track new user sign up
// in 3rd party analytics

export function trackNewUserSignup() {
  const publicPageViews = getAllViewCounters();
  metrics.sendEvent('new_user_signup', publicPageViews, {
    maxEventsPerSession: 1
  });
  deleteAllViewCounters();
}